import { useState } from 'react';
import { useCartStore } from '../../../store/cart-store';
import { useProducts } from './use-products';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

export const useProductDetails = (productId?: string) => {
  const [quantity, setQuantity] = useState(1);
  const { addItem } = useCartStore();
  const { currentProducts, isLoading } = useProducts();
  const navigate = useNavigate(); 
  // Find the product from the already loaded products list
  const product = productId && currentProducts ? 
    currentProducts.find(p => p._id === productId) : 
    null;
  
  const error = !product && !isLoading ? new Error('Product not found') : null;

  const handleQuantityChange = (newQuantity: number) => {
    setQuantity(newQuantity);
  };

  const handleAddToCart = () => {
    if (product) {
      // Add product to cart with quantity
      addItem({
        ...product,
        quantity
      });

      Swal.fire({
        title: 'Producto agregado',
        text: `${product.title} se agregó al carrito`,
        icon: 'success',
        showCancelButton: true,
        confirmButtonText: 'Comprar ahora',
        cancelButtonText: 'Continuar comprando',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/store/cart');
        }
      });
      
    }
  };

  const handleBuyNow = () => {
    if (product) {
      addItem({
        ...product,
        quantity
      });
      navigate('/store/cart');
    }
  };

  return {
    product,
    isLoading,
    error,
    quantity,
    handleQuantityChange,
    handleAddToCart,
    handleBuyNow
  };
};
